import { motion } from "framer-motion";
import { LuMapPin, LuPhone, LuMessageCircle } from "react-icons/lu";

export default function ContactSection() {
    return (
        <section
            id="contact"
            className="py-24 bg-white dark:bg-[#1a1a1a] transition-colors"
        >
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">

                {/* Left Content */}
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-4xl font-serif text-gold">
                        Contact & Location
                    </h2>

                    <p className="mt-6 text-charcoal/80 dark:text-ivory/80 leading-relaxed">
                        We welcome you to experience refined comfort at M R Suites Dharwad.
                        For reservations and enquiries, feel free to reach out to us.
                    </p>

                    {/* Address */}
                    <div className="mt-8">
                        <h3 className="text-xl font-serif text-gold">
                            Address
                        </h3>
                        <div className="mt-8 flex items-start gap-3">
                            <LuMapPin className="text-gold mt-1" size={20} />
                            <p className="text-charcoal/70 dark:text-ivory/70">
                                M R Suites Dharwad<br />
                                Kalburgi Building, P B Road<br />
                                Dharwad, Karnataka - 580008<br />
                            </p>
                        </div>
                    </div>

                    {/* Contact Buttons */}
                    <div className="mt-10 flex flex-wrap gap-4">
                        <a
                            href="tel:+917090628555"
                            className="flex items-center gap-2 px-6 py-3 border border-gold text-gold rounded-full hover:bg-gold hover:text-charcoal transition"
                        >
                            <LuPhone size={18} />
                            Call Now
                        </a>

                        <a
                            href="https://wa.me/917090628555"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-2 px-6 py-3 bg-gold text-charcoal rounded-full hover:scale-105 transition"
                        >
                            <LuMessageCircle size={18} />
                            WhatsApp Enquiry
                        </a>
                    </div>
                </motion.div>

                {/* Map */}
                <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="w-full h-[400px] rounded-2xl overflow-hidden shadow-lg"
                >
                    <iframe
                        title="M R Suites Dharwad Location"
                        src="https://www.google.com/maps?q=Dharwad,Karnataka&output=embed"
                        className="w-full h-full border-0"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </motion.div>

            </div>
        </section>
    );
}